import type { Finra3210Payload } from '@fruitful/investment-management';

import { requestBuilder } from '../../http/RequestBuilder';

interface ApexMoneyMapAgreementUriDto {
    moneyMapAccountId: string;
    agreementUri: string;
}

interface ApexAgreementDisclosuresDto {
    agreementMap: ApexMoneyMapAgreementUriDto[];
}

interface AccountsStepCompletenessAccountIds {
    jointAccountsToOpen: string[];
    memberSoloAccountsToOpen: string[];
    memberJointAccountsToAccept: string[];
    partnerSoloAccountsToOpen: string[];
    partnerJointAccountsToAccept: string[];
}

interface BatchApexAccountsDto {
    agreements: ApexAgreementDisclosuresDto;
    submittedApexAccounts: AccountsStepCompletenessAccountIds;
    ssn?: string;
    finra3210?: Finra3210Payload;
}

export const useCreateMoneyMapApexAccounts = requestBuilder.mutation<
    { success: boolean },
    BatchApexAccountsDto,
    { id: string }
>({
    endpoint: ({ id }) => `/api/money-map/${id}/apex-accounts`,
    method: 'POST',
});
